<div class="select-leader">
	<div *ngIf="showDropZone" [class.dropzone-overlay]="!!entityId" class="dropzone">
		<bb-upload class="upload" (bbFileCreated)="uploadedMediaclipLogo($event)" [multi]="false"
			[publishCreatives]="true" [autoPublish]="autoPublish" [mediaTypes]="['image']"
			[dropText]="'DRAG_DROP_IMAGE' | translate" [showUploadIcon]="true" [createNewMediaclip]="true"
			[dropTextRecommendation]="dropTextRecommendation" [theme]="theme" [useType]="useType"
			[uploadText]="'UPLOAD_FILE'" [dropZoneOnly]="theme === 'light-v2' && entityId">
		</bb-upload>
	</div>
	<div class="leader-logo {{theme }}-theme" *ngIf="entityId">
		<h5 *ngIf="!hasThumbnails">{{ 'MEDIACLIP_HAS_NO_THUMBNAIL' | translate : {mediaclipId: entityId} }}</h5>
		<span class="logo"><img [src]="thumbnailData || (mediaclip | thumbnail:400:240:'url' | async)"></span>
	</div>

	<!-- Buttons -->
	<div *ngIf="theme !== 'light-v2'" class="buttons">
		<bb-button icon="list" (click)="showLogoSelectModal()" [theme]="theme">
			{{ (mediaclip ? 'REPLACE_WITH_EXISTING' : 'SELECT') | translate }}
		</bb-button>
		<bb-upload [publishCreatives]="true" [autoPublish]="autoPublish" (bbFileCreated)="uploadedMediaclipLogo($event)"
			[useType]="useType" [mediaTypes]="mediaTypes" [createNewMediaclip]="true" [hideDropText]="true"
			[uploadText]="(mediaclip ? 'REPLACE' : 'UPLOAD') | translate" [theme]="theme">
		</bb-upload>
		<bb-button icon="remove" *ngIf="entityId" (click)="removeMediaclipLogo()" [theme]="theme">
			{{ 'REMOVE' | translate }}
		</bb-button>
	</div>
	<!-- bit of duplicate code, but light-v2 theme has own order, text and icons -->
	<div *ngIf="theme === 'light-v2'" class="buttons light-v2-theme">
		<bb-button *ngIf="entityId" (click)="removeMediaclipLogo()" [theme]="theme">
			{{ 'CLEAR' | translate }}
		</bb-button>
		<bb-button icon="image-landscape" (click)="showLogoSelectModal()" [theme]="theme">
			{{ 'SELECT_IMAGE' | translate }}
		</bb-button>
		<bb-upload [publishCreatives]="true" [autoPublish]="autoPublish" (bbFileCreated)="uploadedMediaclipLogo($event)"
			[useType]="useType" [mediaTypes]="mediaTypes" [createNewMediaclip]="true" [hideDropText]="true"
			[uploadText]="'UPLOAD_FILE'" [theme]="theme">
		</bb-upload>
	</div>
</div>

<ng-template #selectLogoTemplate>
	<bb-mediaclip-selector [mediaTypes]="mediaTypes" (canceled)="removeModal()"
		(selected)="selectMediaclipLogo($event?.data)" [bbTableService]="bbTableService"></bb-mediaclip-selector>
</ng-template>
